import React from "react";
import { Grid, Typography } from "@mui/material";
import DetailRow from "../../pages/common-features/DetailRow";
import SummarySectionHeader from "../../components/applicantDetailsTabs/SummarySectionHeader";


interface ExpenseDetailsTabProps {
  expenseDetails: any[];
  isMobile: boolean;
}

const ExpenseDetailsTab: React.FC<ExpenseDetailsTabProps> = ({
  expenseDetails,
  isMobile,
}) => {
  if (!expenseDetails || expenseDetails.length === 0)
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          No details available.
        </Typography>
      </Grid>
    );

  // define specific order of keys
  const expenseKeys = [
    "tuitionFees",
    "livingExpenses",
    "travelExpenses",
    "otherExpenses",
    "vasExpense",
  ];

  const fundKeys = [
    "loanRequestedAmt",
    "ownSourceAmt",
    "scholarshipAmt",
    "otherIncomeAmt",
  ];

  // displaying this fields separately
  const totalExpenseObj = expenseDetails.find((item) => item.key === "totalExpenseAmt");
  const totalFundsObj = expenseDetails.find((item) => item.key === "totalFundsAmt");

  // find and sort items based on the key list
  const getOrderedData = (keys: string[]) => {
    return keys
      .map((key) => expenseDetails.find((item) => item.key === key))
      .filter((item) => item !== undefined); // Remove undefined if a key is missing
  };

  const expenseData = getOrderedData(expenseKeys);
  const fundsData = getOrderedData(fundKeys);

  const renderGridItems = (items: any[]) => {
    return items.map((field: any, subIndex: number) => (
      <Grid item xs={12} sm={6} md={3} key={`${field.key}-${subIndex}`} sx={{ ml: isMobile ? 2 : 0 }}>
        <DetailRow
          item={{ label: field.label === 'VAS Expense' ? "VAS Expenses" : field.label, value: field.value, isVerified: false }}
        />
      </Grid>
    ));
  };

  // Reusable style for the headers
  const headerStyle = {
    fontSize: "15px",
    fontWeight: 600,
    color: "#6f6b7d",
    mb: 1,
  };

  const highlightStyle = {
    fontSize: "13px",
    fontWeight: 700,
    color: "#04a0a2",
    ml: 1,
    mb: 1,
  };

  return (
    <Grid container xs={12} spacing={2} sx={{ pl: isMobile ? 0 : 3 }}>
      {/* expense section */}
      <Grid item xs={12} sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
        <SummarySectionHeader
          title={
            <>
              Expense Details
              {totalExpenseObj && (
                <Typography sx={{...highlightStyle, display: "inline",ml: 1,}}>
                  | {totalExpenseObj.label}: ₹{' '}
                  {new Intl.NumberFormat('en-IN', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  }).format(Number(totalExpenseObj.value))}
                </Typography>
              )}
            </>
          }
        />
        {/* <Typography sx={headerStyle}>
          Expense Details
        </Typography> */}

        {/* {totalExpenseObj && (
          <Typography sx={highlightStyle}>
            | {totalExpenseObj.label}: ₹ {new Intl.NumberFormat("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(Number(totalExpenseObj.value))}
          </Typography>
        )} */}
      </Grid>

      {renderGridItems(expenseData)}

      {/* funds section */}
      <Grid item xs={12} sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
        <SummarySectionHeader
          title={
            <>
              Fund Details
              {totalFundsObj && (
                <Typography sx={{...highlightStyle, display: "inline",ml: 1,}}>
                  | {totalFundsObj.label}: ₹{' '}
                  {new Intl.NumberFormat('en-IN', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  }).format(Number(totalFundsObj.value))}
                </Typography>
              )}
            </>
          }
        />
        {/* <Typography sx={headerStyle}>
          Funds Details
        </Typography> */}

        {/* {totalFundsObj && (
          <Typography sx={highlightStyle}>
             | {totalFundsObj.label}: ₹ {new Intl.NumberFormat("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(Number(totalFundsObj.value))}
          </Typography>
        )} */}
      </Grid>

      {renderGridItems(fundsData)}
    </Grid>
  );
};

export default ExpenseDetailsTab;
